import React from 'react';

import { useClearCustomBotPreview } from '../../../../../hooks/useClearCustomBotPreview';

import { TEST_VIEW } from '../../../../../constants/bot';

import { ButtonIcon } from '../../../../../design-system';
import ViewToggle from '../ViewToggle/ViewToggle';
import EditBoxLineIcon from '../../../../../design-system/Icons/EditBoxLineIcon';

const ChatHeader = ({ isChatLoading = false, view, setView }) => {
    const { clearAssistantPreview, clearApiPreview } = useClearCustomBotPreview();

    const openNewChat = () => {
        if (view === TEST_VIEW.assistant) clearAssistantPreview();

        if (view === TEST_VIEW.api) clearApiPreview();
    };

    const title = {
        [TEST_VIEW.assistant]: 'Assistant Preview',
        [TEST_VIEW.api]: 'API Preview',
    }[view];

    return (
        <div className="px-4 3xl:px-6 pb-4 pt-[18px] flex items-center justify-between gap-2 relative">
            <ButtonIcon
                type="link"
                size="xs"
                icon={EditBoxLineIcon}
                state={isChatLoading ? 'disabled' : 'default'}
                onClick={openNewChat}
            />

            <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-body-bold text-body-bold-m text-black">
                {title}
            </p>

            <div className="min-w-[28px]">
                <ViewToggle view={view} setView={setView} />
            </div>
        </div>
    );
};

export default ChatHeader;
